import BigNumber from 'bignumber.js'
import { getXpVaultContract } from 'utils/contractHelpers'

const xpVaultContract = getXpVaultContract()

const fetchVaultUser = async (account: string) => {
  try {
    const userContractResponse = await xpVaultContract.userInfo(account)
    return {
      isLoading: false,
      userShares: new BigNumber(userContractResponse.shares.toString()).toJSON(),
      lastDepositedTime: userContractResponse.lastDepositedTime.toString(),
      lastUserActionTime: userContractResponse.lastUserActionTime.toString(),
      xpAtLastUserAction: new BigNumber(userContractResponse.xpAtLastUserAction.toString()).toJSON(),
    }
  } catch (error) {
    return {
      isLoading: true,
      userShares: null,
      lastDepositedTime: null,
      lastUserActionTime: null,
      xpAtLastUserAction: null,
    }
  }
}

export default fetchVaultUser
